var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858585",
    d: "M13.794,68.2a.714.714,0,0,0-.99,0L4.418,76.354,1.194,73.219a.714.714,0,0,0-.99,0,.668.668,0,0,0,0,.963L3.923,77.8a.714.714,0,0,0,.99,0l8.881-8.638A.668.668,0,0,0,13.794,68.2Z",
    transform: "translate(0 -67.997)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.54640941da07dfded08f3fb4ca605095.svg";
export { ForwardRef as ReactComponent };